module.exports = __webpack_public_path__ + "static/media/wizualizacja-32.9fed786f.png";